import React from "react"
import * as PropTypes from "prop-types"

import {FormattedMessage} from "@irati/utils/lang"
import id from "@irati/utils/id"
import {RouterLink} from "@irati/ui/src/Link"

const RecognitionMenuLink = (props, {apps}) => {
  return (
    <RouterLink plain id={id("link-my-recognition", props)} to="/account/my-recognition" app={apps.RECOGNITION}>
      <FormattedMessage id="platform.userMenuContext.recognition.href.text" />
    </RouterLink>
  )
}

RecognitionMenuLink.contextTypes = {
  apps: PropTypes.object.isRequired
}

export default RecognitionMenuLink
